import { CaretRightIcon } from '@phosphor-icons/react';

import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const ArrowRightSmall = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return <CaretRightIcon size={Sizes[size]} {...rest} color={stroke || fill} />;
};

ArrowRightSmall.displayName = 'ArrowRightSmall';
